import AdLoadReviewTable from "./reviewStep/AdLoadReviewTable";

const ReviewStep = () => {
  return <AdLoadReviewTable />;
};

export default ReviewStep;
